import allJson from './all.json';

export class ApiResponseJson{
  public all: any;

  constructor() {
    this.all = allJson;
  }

  getData(route: string) {
    return this.all[route];
  }
}
